import { Component, EventEmitter, Input, Output } from '@angular/core';
import { forkJoin } from 'rxjs';
import { SupportTicket } from '../models/ticket.model';
import { TicketService } from '../services/ticket.service';

@Component({ selector: 'ft-ticket-detail', templateUrl: './ticket-detail.component.html', styleUrls: ['./ticket-detail.component.scss'], standalone: false })
export class TicketDetailComponent {
  @Input({ required: true }) ticket!: SupportTicket;
  @Output() back = new EventEmitter<void>();
  @Output() ticketChanged = new EventEmitter<SupportTicket>();
  message = '';
  files: File[] = [];
  submitting = false;
  errorMessage = '';

  constructor(private tickets: TicketService) {}

  get closed(): boolean { return this.ticket.status === 'CLOSED' || this.ticket.status === 'CANCELLED'; }
  get canReply(): boolean { return !this.closed && (!!this.message.trim() || this.files.length > 0); }

  onFilesSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const selected = Array.from(input.files ?? []).filter(file => file.size <= 10 * 1024 * 1024);
    this.files = [...this.files, ...selected].slice(0, 5); input.value = '';
  }
  removeFile(index: number): void { this.files.splice(index, 1); }

  submitReply(): void {
    if (!this.canReply) return;
    this.submitting = true; this.errorMessage = '';
    const operations = [];
    if (this.message.trim()) operations.push(this.tickets.addMessage(this.ticket.id, this.message.trim()));
    this.files.forEach(file => operations.push(this.tickets.uploadAttachment(this.ticket.id, file)));
    forkJoin(operations).subscribe({
      next: () => this.refresh(),
      error: error => { this.submitting = false; this.errorMessage = this.error(error, 'Unable to send your reply.'); },
    });
  }

  retrySync(): void {
    this.submitting = true; this.errorMessage = '';
    this.tickets.retrySync(this.ticket.id).subscribe({
      next: ticket => { this.ticket = ticket; this.submitting = false; this.ticketChanged.emit(ticket); },
      error: error => { this.submitting = false; this.errorMessage = this.error(error, 'Unable to retry synchronization.'); },
    });
  }

  refresh(): void {
    this.tickets.getTicket(this.ticket.id).subscribe({
      next: ticket => { this.ticket = ticket; this.message = ''; this.files = []; this.submitting = false; this.ticketChanged.emit(ticket); },
      error: error => { this.submitting = false; this.errorMessage = this.error(error, 'Unable to refresh the ticket.'); },
    });
  }

  openAttachment(url: string): void { window.open(url, '_blank', 'noopener'); }
  initials(name: string): string { return name.split(/\s+/).filter(Boolean).slice(0, 2).map(part => part[0]).join('').toUpperCase() || 'U'; }
  displayStatus(status: string): string { return status.replace(/_/g, ' '); }
  trackConversation(_: number, item: { id: number }): number { return item.id; }
  trackAttachment(_: number, item: { id: number }): number { return item.id; }
  trackFile(_: number, file: File): string { return `${file.name}-${file.size}`; }
  private error(error: unknown, fallback: string): string { const value = error as { error?: { message?: string } }; return value?.error?.message || fallback; }
}
